module.exports = __webpack_public_path__ + "img/special-warning-icons-orion.d4e5f870.svg";